import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, Sun, Battery, Zap, Shield, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <BrandLogo className="h-10 w-auto" />
            </div>
            <p className="text-gray-600 mb-4">
              Leading the way in intelligent energy design solutions with AI-powered technology.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-gray-900">Solutions</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors flex items-center">
                  <Sun className="h-4 w-4 mr-2 text-yellow-500" />
                  Solar Solutions
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors flex items-center">
                  <Battery className="h-4 w-4 mr-2 text-green-500" />
                  Battery Storage
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors flex items-center">
                  <Zap className="h-4 w-4 mr-2 text-blue-500" />
                  Hybrid Systems
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors flex items-center">
                  <Shield className="h-4 w-4 mr-2 text-blue-600" />
                  Energy Monitoring
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors flex items-center">
                  <Users className="h-4 w-4 mr-2 text-blue-600" />
                  Commercial Solutions
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-gray-900">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about-us" className="text-gray-600 hover:text-blue-600 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/our-team" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Our Team
                </Link>
              </li>
              <li>
                <Link to="/why-solar" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Why Choose Us
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-600 hover:text-blue-600 transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/key-benefits" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Key Benefits
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-gray-900">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-600">
                <Phone className="h-4 w-4 mr-2 text-blue-600" />
                920005469
              </li>
              <li className="flex items-center text-gray-600">
                <Mail className="h-4 w-4 mr-2 text-blue-600" />
                info@gasable.com
              </li>
              <li className="flex items-center text-gray-600">
                <MapPin className="h-4 w-4 mr-2 text-blue-600" />
                Abu Bakr Al Siddiq Road – Al Masif, Riyadh - Saudi Arabia
              </li>
            </ul>

            {/* Newsletter */}
            <div className="mt-6">
              <h4 className="text-sm font-semibold mb-2 text-gray-900">Subscribe to our newsletter</h4>
              <div className="flex flex-col sm:flex-row">
                <input
                  type="email"
                  placeholder="Your email"
                  className="bg-gray-100 text-gray-900 px-4 py-2 rounded-lg sm:rounded-r-none focus:outline-none focus:ring-1 focus:ring-blue-500 border border-gray-200 flex-grow mb-2 sm:mb-0"
                />
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg sm:rounded-l-none transition-colors">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">
              © 2024 ENTEK.AI. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center space-x-4 mt-4 md:mt-0">
              <a href="#" className="text-gray-500 hover:text-blue-600 text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-600 text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-600 text-sm transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
